import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentUserService } from '@services/current-user.service';
import { Role } from '@app/domain/models';
import { map } from 'rxjs/operators';

export const adminRoleGuard: CanActivateFn = () => {
    const currentUserService = inject(CurrentUserService);
    const router = inject(Router);

    return currentUserService.load(true).pipe(
        map((user) => {
            if (user?.role === Role.ADMIN) return true;
            router.navigate(['/dashboard']);
            return false;
        }),
    );
};
